import {
  DataTablePrimeReact,
  IColumnProps,
  TableERP,
} from "@finanedi.es/storybook"
import { DataTableRowClickEventParams } from "primereact/datatable"
import { RefObject } from "react"
import { useTranslation } from "react-i18next"
import { CarteraTableProps } from "../constants"

export interface TableCarteraProps {
  columns: IColumnProps[]
  refTable: RefObject<DataTablePrimeReact<CarteraTableProps[]>>
  items: CarteraTableProps[] | undefined
  loading: boolean
  onRowClick?: ({
    data,
    originalEvent: { target },
  }: DataTableRowClickEventParams) => void
  selection: CarteraTableProps[]
  onSelectionChange: (e: { value: CarteraTableProps[] }) => void
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
}

export const TableCartera: React.FC<TableCarteraProps> = ({
  columns,
  refTable,
  items,
  loading,
  onRowClick,
  selection,
  onSelectionChange,
  onSort,
  sortField,
  sortOrder,
}: TableCarteraProps) => {
  const { t } = useTranslation()

  return (
    <TableERP
      refTable={refTable}
      data-testid='tabla-cartera'
      id='tabla-cartera'
      className='tw-h-full !tw-z-0'
      dataKey='id'
      columns={columns}
      value={items}
      loading={loading}
      selection={selection}
      selectionMode='checkbox'
      selectionColumnMode='multiple'
      onSelectionChange={onSelectionChange}
      size='small'
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      onRowClick={onRowClick}
      removableSort
      showGridlines
      lazy
      scrollable
      emptyMessage={t("primeReact.table.emptyMessage")}
    />
  )
}
